<div class="banner">
  <img class="logo" src="../../../assets/toobook-logo.png" alt="Logo Toobook" />
</div>
